import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

function StatusIcon({ value, size }) {
  // AVERAGE SIZE
  const status = () => {
    const checkValue = () => {
      switch (value) {
        case 'PENDING':
          return <span className="pending">PENDING</span>;
        case 'FOR CHECKING':
          return <span className="for-appearance">FOR CHECKING</span>;
        case 'SYNCED':
          return <span className="synced">SYNCED</span>;
        case 'FOR APPRAISAL AND ASSESSMENT':
          return <span className="for-appearance">FOR APPRAISAL AND ASSESSMENT</span>;
        case 'FOR REASSESSMENT':
          return <span className="reject">FOR REASSESSMENT</span>;
        case 'FOR RESUBMISSION':
          return <span className="reject">FOR RESUBMISSION</span>;
        case 'POSTED':
          return <span className="printed">POSTED</span>;
        case 'PENDING LAB TEST':
          return <span className="for-appearance">PENDING LAB TEST</span>;
        case 'FOR PICK-UP':
          return <span className="for-appearance">FOR PICK-UP</span>;
        case 'FOR APPEARANCE':
          return <span className="for-appearance">FOR APPEARANCE</span>;
        case 'PROCESSING':
          return <span className="processing">PROCESSING</span>;
        case 'REJECT':
          return <span className="reject">REJECTED</span>;
        case 'WAITING FOR PAYMENT':
          return <span className="waiting">WAITING FOR PAYMENT</span>;
        case 'PAID':
          return <span className="paid">PAID</span>;
        case 'FOR ASSESSMENT (ADMIN)':
          return <span className="paid">FOR ASSESSMENT (ADMIN)</span>;
        case 'FOR ASSESSMENT (TREASURY)':
          return <span className="paid">FOR ASSESSMENT (TREASURY)</span>;
        case 'FINALIZED':
          return <span className="paid">FINALIZED</span>;
        case 'RECEIVED':
          return <span className="paid">RECEIVED</span>;
        case 'REJECTED':
          return <span className="rejected">REJECTED</span>;
        case 'FOR PRINTING':
          return <span className="for-printing">FOR PRINTING</span>;
        case 'PRINTED':
          return <span className="printed">PRINTED</span>;
        case 'VERIFIED':
          return <span className="paid">VERIFIED</span>;
        default:
          return <span className="pending">{value}</span>;
      }
    };
    return <div className="status-container">{checkValue()}</div>;
  };

  // SMALL SIZE
  const statusSm = () => {
    const checkValue = () => {
      switch (value) {
        case 'PENDING':
          return <span className="pending">PENDING</span>;
        case 'FOR PICK-UP':
          return <span className="pending">FOR PICK-UP</span>;
        case 'PENDING LAB TEST':
          return <span className="for-appearance">PENDING LAB TEST</span>;
        case 'PROCESSING':
          return <span className="processing">PROCESSING</span>;
        case 'REJECT':
          return <span className="reject">REJECTED</span>;
        case 'WAITING FOR PAYMENT':
          return (
            <span className="waiting">
              WAITING TO PAY FROM PAYMENT PROVIDER
            </span>
          );
        case 'PAID':
          return <span className="paid">PAID</span>;
        default:
          return <span className="pending">{value}</span>;
      }
    };
    return <div className="status-container-sm">{checkValue()}</div>;
  };
  return _.isEmpty(size) ? (
    status()
  ) : (
    <React.Fragment>{size === 'SM' ? statusSm() : status()}</React.Fragment>
  );
}

StatusIcon.propTypes = {
  value: PropTypes.string,
  size: PropTypes.string,
};
StatusIcon.defaultProps = {
  value: '',
  size: '',
};

export default StatusIcon;
